export enum STATUS_TYPE_FILE_BUILD {
  GERBER = "Gerber",
  BOM = "BOM",
  STACKUP = "Stackup",
  ASSEMBLY = "Assembly",
  ATTACHMENT = "Attachment",
  MECH_3D = "3D file",
}
